import * as React from "react";
const SvgRuler = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 22L2 18L3.6 16.4L5.2 18L6 17.2L4.4 15.6L6 14L6.8 14.8L7.6 14L6.8 13.2L8.4 11.6L10 13.2L10.8 12.4L9.2 10.8L10.8 9.2L11.6 10L12.4 9.2L11.6 8.4L13.2 6.8L14.8 8.4L15.6 7.6L14 6L15.6 4.4L16.4 5.2L17.2 4.4L16.4 3.6L18 2L22 6L6 22Z", fill: "currentColor" }));
export default SvgRuler;
